import { render, staticRenderFns } from "./MantraHome.vue?vue&type=template&id=cecdf25e&"
import script from "./MantraHome.vue?vue&type=script&lang=js&"
export * from "./MantraHome.vue?vue&type=script&lang=js&"
import style0 from "./MantraHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports